import React from 'react';
import userIcon from '../../../images/img/user.svg'


const MessageA7 = (props) => {


    return (
        <> <div style={{ display: 'flex',width:'100%' }}>   
            
            {/* <div className="chat-text" style={{ margin: '10px 10px' }} dangerouslySetInnerHTML={{ __html: props.item.text }}>

            </div> */}
                    <div className="onclick-inner" style={{ display: 'flex', width: '100%', alignItems: 'center', justifyContent: 'flex-end' }}> <span className="packs-img" >{JSON.parse(localStorage.getItem("userName")) !== "Testing" ? localStorage.getItem("userName").toString()?.match(/\b(\w)/g).join('') : <img height = "15" width= "15" src={userIcon}></img>}</span> <span className="packs-text" style={{maxWidth:"87%"}}>{props.item.text}</span> </div>
        {/* <div><div className="delivery-time-first" >{timeCurrent}<span><img src={deliveryTimeIcon} className="img-fluid" alt="" /></span></div></div> */}


        </div>
        </>
    )
}


export default MessageA7;